import {
  WorkflowStepStatuses,
  type WorkflowStepUser,
  WorkflowStepUserResponses,
  type WorkflowStepInput,
  type WorkflowTemplate,
} from "~/api/types";
import useUsers from "~/api/swr/useUsers";
import { UserStatus, PlatformRole } from "~/config/types";

export function useWorkflowUsers() {
  const { data: allUsers } = useUsers({
    status: [UserStatus.active, UserStatus.pending],
    roles: [
      PlatformRole.superAdmin,
      PlatformRole.coordinator,
      PlatformRole.contributor,
    ],
  });

  const hydrateSteps = (template: WorkflowTemplate): WorkflowStepInput[] => {
    return template.steps.map((step, i) => ({
      _key: `${step.id ?? i}`,
      id: step.id,
      name: step.name,
      description: step.description ?? "",
      type: step.type,
      order: i,
      status: WorkflowStepStatuses.upcoming,
      dueAt: step.dueAt ? new Date(step.dueAt) : null,
      users: step.users.map((u): WorkflowStepUser => {
        const info = allUsers?.find((user) => user.id === u.userId);
        return {
          userId: u.userId,
          firstName: info?.firstName ?? "Unknown",
          lastName: info?.lastName,
          imageUrl: info?.imageUrl,
          permission: u.permission,
          responseStatus: WorkflowStepUserResponses.pending,
        };
      }),
    }));
  };

  return { hydrateSteps };
}
